export default "__VITE_ASSET__owiMCSrp__"